import { SideListProps } from 'apps/frontend/types/Types';
import styles from './sidelist.module.css';
import { FC, useEffect, useState } from 'react';
import newsImage from '../../../../styles/images/cnbc-default-image.webp';
import Title from 'apps/frontend/components/Title';
import GetData from 'apps/frontend/services/GetData';
import { requests, fileUrl } from 'apps/frontend/services/Requests';
import Link from 'next/link';
import TimeAgoArabicFormat from '../../TimeAgoCustom/TimeAgoArabicFormat';
import CategoriesLinks from '../../CategoriesLinks/CategoriesLinks';
import LatestNewsList from 'apps/frontend/components/Home/LatestNewsList/LatestNewsList';
import SkeletonLoader from '../../SkeletonLoader/SkeletoLoader';
import {
  mapFlagBasedResponse,
  handleElkAndDbResponse,
} from '../../../../services/ResponseMapping';
import { trendingNowTitle } from 'apps/frontend/services/ArabicTitles';
import { buildNewsRoute } from 'apps/frontend/services/Util';
import Thumbnail from 'apps/frontend/components/Thumbnail';

const SideList: FC<SideListProps> = ({ type, title }) => {
  const [mostReadNewsList, setMostReadNewsList] = useState<any>({});
  const [trendingNewsList, setTrendingNewsList] = useState<any>([]);
  const [marketNewsList, setMarketNewsList] = useState<any>([]);
  const [stockNewsList, setStockNewsList] = useState<any>([]);
  const [trendingLoader, setTrendingLoader] = useState<boolean>(false);
  const [mostReadLoader, setMostReadLoader] = useState<boolean>(false);
  const [marketLoader, setMarketLoader] = useState<boolean>(false);
  const [stockLoader, setStockLoader] = useState<boolean>(false);

  useEffect(() => {
    if (title != 'أخبار الأسواق' && title != 'أخبار الشركات') {
      setMostReadLoader(true);
      GetData(`${requests.mostReadNews}&limit=5&offset=0`, {}, 'get', false)
        .then((res) => {
          const newsRes = res.data?.response ? res.data?.response : {};
          setMostReadLoader(false);
          setMostReadNewsList(newsRes);
        })
        .catch((err) => {
          setMostReadLoader(false);
          console.warn(err);
        });
    } else if (title == 'أخبار الأسواق') {
      setMarketLoader(true);
      GetData(`${requests.latestMarketCategory}`, {}, 'get', false)
        .then((res) => {
          const marketNewsCategoryId = res?.data?.response?.id;
          marketNewsCategoryId &&
            GetData(
              `${requests.newsByCategories}${marketNewsCategoryId}?limit=6&pageNo=1`,
              {},
              'get',
              false
            )
              .then((result) => {
                let newsResult = mapFlagBasedResponse(result?.data);
                setMarketLoader(false);
                setMarketNewsList(newsResult);
              })
              .catch((err) => {
                setMarketLoader(false);
                console.warn(err);
              });
        })
        .catch((err) => {
          console.warn(err);
        });
    } else if (title == 'أخبار الشركات') {
      setStockLoader(true);
      GetData(`${requests.latestStockCategory}`, {}, 'get', false)
        .then((res) => {
          const stockNewsCategoryId = res?.data?.response?.id;
          stockNewsCategoryId &&
            GetData(
              `${requests.newsByCategories}${stockNewsCategoryId}?limit=6&pageNo=1`,
              {},
              'get',
              false
            )
              .then((result) => {
                let newsResult = mapFlagBasedResponse(result?.data);
                setStockLoader(false);
                setStockNewsList(newsResult);
              })
              .catch((err) => {
                setStockLoader(false);
                console.warn(err);
              });
        })
        .catch((err) => {
          console.warn(err);
        });
    }

    setTrendingLoader(true);
    GetData(`${requests.trendingNews}&limit=5&pageNo=1`, {}, 'get', false)
      .then((res) => {
        let newsResult = res.data && res.data.length ? res.data : [];
        newsResult = handleElkAndDbResponse(newsResult);
        setTrendingLoader(false);
        setTrendingNewsList(newsResult);
      })
      .catch((err) => {
        setTrendingLoader(false);
        console.warn(err);
      });

    return () => {
      // This code runs when component is unmounted
      setMostReadNewsList({});
      setTrendingNewsList([]);
    };
  }, []);

  return (
    <>
      <div className={styles.sidebar}>
        <div className={styles.listBody}>
          {type === 'numbered' &&
            (title === 'الأكثر قراءة' ? ( // show most read news :: api data
              <>
                <div className="sideSimpleListWrap">
                  <Title styles={styles.themeTitle}>
                    <h4> {title} </h4>
                  </Title>
                  <ul className={styles.sidenumberList}>
                    {mostReadLoader && <SkeletonLoader count={15} />}
                    {mostReadNewsList &&
                      Object.keys(mostReadNewsList).length > 0 && (
                        <>
                          {Object.values(mostReadNewsList).map(
                            (newsItem: any, index: number) => {
                              newsItem['routePath'] = buildNewsRoute(newsItem?.id, newsItem?.createdAt, newsItem?.seoDetail?.slugLine, newsItem?.title);
                              return (
                                <li key={index}>
                                  <Link href={`/${newsItem?.routePath}/`}>
                                    <a href="#" aria-label="Go to 116">{newsItem?.title}</a>
                                  </Link>
                                </li>
                              );
                            }
                          )}
                        </>
                      )}
                  </ul>
                </div>
              </>
            ) : title === 'الأكثر تداولا' ? ( // show trending now news :: api data
              <>
                <div className="sideSimpleListWrap mostPopular">
                  <Title styles={styles.themeTitle}>
                    <h4> {trendingNowTitle} </h4>
                  </Title>
                  <ul className={styles.sidenumberList}>
                    {trendingLoader && <SkeletonLoader count={5} />}
                    {trendingNewsList?.length > 0 &&
                      trendingNewsList?.map((newsItem: any, index: number) => {
                        return (
                          <li key={index}>
                            <Link href={`/${newsItem?.routePath}/`}>
                              <a href="#" aria-label="Go to 117">{newsItem?.title}</a>
                            </Link>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </>
            ) : (
              <>
                <div className="sideSimpleListWrap">
                  <Title styles={styles.themeTitle}>
                    <h4>
                      {' '}
                      {title} `{'static'}`
                    </h4>
                  </Title>
                  <ul className={styles.sidenumberList}></ul>
                </div>
              </>
            ))}
          {type === 'simple' &&
            (title === 'الأكثر قراءة' ? ( // show most read news :: api data
              <>
                <div className="sideSimpleListWrap">
                  <Title styles={styles.themeTitle}>
                    <h4> {title} </h4>
                  </Title>

                  <ul className={styles.sidesimpleList}>
                    {mostReadLoader && <SkeletonLoader count={15} />}
                    {mostReadNewsList &&
                      Object.keys(mostReadNewsList).length > 0 && (
                        <>
                          {Object.values(mostReadNewsList).map(
                            (newsItem: any, index: number) => {
                              newsItem['routePath'] = buildNewsRoute(newsItem?.id, newsItem?.createdAt, newsItem?.seoDetail?.slugLine, newsItem?.title);
                              const imagePath =
                                newsItem?.contentType === 'VIDEO' &&
                                newsItem?.thumbnail?.url
                                  ? newsItem?.thumbnail?.url
                                  : newsItem?.thumbnail?.path
                                  ? fileUrl + newsItem?.thumbnail?.path
                                  : newsItem?.image?.url
                                  ? newsItem?.image?.url
                                  : newsItem?.image?.path
                                  ? fileUrl + newsItem?.image?.path
                                  : newsImage.src;
                              return (
                                <li key={index}>
                                  <div className="NewsImage show_mobile">
                                    <Link href={`/${newsItem?.routePath}/`}>
                                      <a href="#" aria-label="Go to 118">
                                        <Thumbnail
                                          className="img-fluid"
                                          src={imagePath}
                                        />
                                      </a>
                                    </Link>
                                  </div>
                                  <Link href={`/${newsItem?.routePath}/`}>
                                    <a href="#" aria-label="Go to 119">{newsItem?.title}</a>
                                  </Link>
                                  <p>
                                    <CategoriesLinks
                                      categories={
                                        newsItem && newsItem?.categories
                                      }
                                    />
                                    <b>
                                      <TimeAgoArabicFormat
                                        date={newsItem?.createdAt}
                                      />
                                    </b>
                                  </p>
                                </li>
                              );
                            }
                          )}
                        </>
                      )}
                  </ul>
                </div>
              </>
            ) : (title === 'أخبار الشركات' ? ( // stock news :: api data
            <>
              <div className="sideSimpleListWrap">
                  <Title styles={styles.themeTitle}>
                    <h4> {title} </h4>
                  </Title>

                  <ul className={styles.sidesimpleList}>
                    {stockLoader && <SkeletonLoader count={15} />}
                    {stockNewsList?.length > 0 &&
                      stockNewsList?.map((newsItem: any, index: number) => {
                        return (
                          <li key={index}>
                            <div className="NewsImage show_mobile image_none_tab">
                              <Thumbnail className="img-fluid" src={newsImage.src} />
                            </div>
                            <Link
                              href={`/${newsItem?.routePath}/`}
                            >
                              <a href="#" aria-label="Go to 120">{newsItem?.title}</a>
                            </Link>
                            <p>
                              <CategoriesLinks
                                categories={newsItem && newsItem?.categories}
                              />
                              <b>
                                <TimeAgoArabicFormat
                                  date={newsItem?.createdAt}
                                />
                              </b>
                            </p>
                          </li>
                        );
                      })}
                  </ul>
                </div>
            </>
            )  : (
              <>
                <div className="sideSimpleListWrap">
                  <Title styles={styles.themeTitle}>
                    <h4> {title} </h4>
                  </Title>

                  <ul className={styles.sidesimpleList}>
                    {marketLoader && <SkeletonLoader count={15} />}
                    {marketNewsList?.length > 0 &&
                      marketNewsList?.map((newsItem: any, index: number) => {
                        return (
                          <li key={index}>
                            <div className="NewsImage show_mobile image_none_tab">
                              <Thumbnail className="img-fluid" src={newsImage.src} />
                            </div>
                            <Link
                              href={`/${newsItem?.routePath}/`}
                            >
                              <a href="#" aria-label="Go to 121">{newsItem?.title}</a>
                            </Link>
                            <p>
                              <CategoriesLinks
                                categories={newsItem && newsItem?.categories}
                              />
                              <b>
                                <TimeAgoArabicFormat
                                  date={newsItem?.createdAt}
                                />
                              </b>
                            </p>
                          </li>
                        );
                      })}
                  </ul>
                </div>
              </>
            )))}
          {type === 'dotList' &&
            (title === 'آخر الأخبار' ? ( // show lates news :: api data
              <>
                <Title styles={styles.themeTitle}>
                  <h4> {title} </h4>
                </Title>
                <div className="dotListwrap">
                  <LatestNewsList limit={10} displayMoreButton={true} />
                </div>
              </>
            ) : (
              <>
                <Title styles={styles.themeTitle}>
                  <h4> {title} </h4>
                </Title>
                <div className="dotListwrap">
                  {
                    <div className="text-center mt-3 d-lg-none more_btn">
                      <button className="btn btn-outline-primary">
                        المزيد
                      </button>
                    </div>
                  }
                </div>
              </>
            ))}
        </div>
      </div>
    </>
  );
};

export default SideList;
